<template>
    <div class="header-wrap">
        <div v-if="!isShowCareMenu" class="header-left">
            <!--            <router-link to="/madmin/member/edit" class="com-btn middle">회원등록</router-link>-->
            <button class="header-menu" @click="onClickBtnAddMember">회원등록</button>
            <!--            <router-link to="#" class="com-btn middle">이용권 결제</router-link>-->
            <button
                class="header-menu"
                @click="
                    checkAllowedClick('LE', 1, () => {
                        $router.push({ path: `/madmin/member/account/${centerId}` });
                    })
                "
            >
                이용권 결제
            </button>
            <button
                class="header-menu"
                @click="
                    checkAllowedClick('ME', 1, () => {
                        $router.push({ path: '/madmin/message/send' });
                    })
                "
            >
                메시지 전송
            </button>
            <button class="header-menu" @click="togglePayLinkPop(true)">결제링크 전송</button>
            <button v-if="isAllowedMenu('TC')" class="header-menu" @click="goPage">터치출석</button>
        </div>

        <div v-if="!isShowCareMenu" class="header-right">
            <span class="info-line header-right-date">
                <span v-if="c.cp_contract_start_dt !== null">
                    {{ c.cp_contract_start_dt | timestampFilter }} ~
                    {{ c.cp_contract_end_dt | timestampFilter }}
                </span>
                <span v-if="c.cp_diff_day !== null" :class="['expire', c.cp_diff_day <= limitAlertDay ? 'red' : '']">
                    ({{ getPeriodString(c.cp_diff_day) }})
                </span>
            </span>
            <div class="point-remain">
                <p>포인트 잔여금액 {{ remains.point | numberFormatFilter }} 원</p>
            </div>
            <div class="search-box">
                <img src="/img/icon/search.png" class="search-icon" />
                <input
                    v-model="searchCustomerStr"
                    placeholder="회원명, 연락처 입력('-'제외)"
                    type="text"
                    @keyup.enter="onClickSearchCustomer"
                />
                <button class="btn" type="button" @click="onClickSearchCustomer">
                    <span class="blind">검색하기</span>
                </button>
            </div>
            <!--
      관련 기능 요구 사항이 정의되지 않았기 때문에 주석처리함.
      <div class="alert-box">
          <button type="button" class="alert">
              <span class="num">2</span>
          </button>
      </div>
      -->
        </div>

        <!-- 터치출석 팝업 -->
        <div v-show="touchPop" class="layer-pop touch-pop">
            <div class="view-content">
                <button class="close" @click="touchPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="view-area com-scroll-y">
                    <div class="left-box">
                        <span class="photo-cnt">
                            <img alt="" src="/img/temp/layer_select_photo.jpg" />
                            <span class="name">[홍길동]</span>
                        </span>
                        <div class="info-cnt">
                            <span class="title">락커</span>
                            <ul class="list">
                                <li>
                                    <span class="tit">구분</span>
                                    <span class="detail">복도앞 락커</span>
                                </li>
                                <li>
                                    <span class="tit">번호</span>
                                    <span class="detail">공통 / 101-150</span>
                                </li>
                                <li>
                                    <span class="tit">대여기간</span>
                                    <span class="detail">2019-02-01 ~ 2019.09.01</span>
                                </li>
                                <li>
                                    <span class="tit">남은기간</span>
                                    <span class="detail"><span class="red">2일</span></span>
                                </li>
                            </ul>
                        </div>
                        <div class="info-cnt">
                            <span class="title">만료예정 수업</span>
                            <div class="round-item">
                                <ul class="round-list">
                                    <li>
                                        <!--
                    <span class="ico type-1">필라테스 주 2회 <span class="ic">개인</span></span>
                    <span class="ico type-2">필라테스 주 2회 <span class="ic">그룹</span></span>
                    <span class="ico type-3">필라테스 주 2회 <span class="ic">패키지</span></span>
                    <span class="ico type-4">필라테스 주 2회 <span class="ic">회원권</span></span>
                    <span class="ico type-5">필라테스 주 2회 <span class="ic">듀엣</span></span>
                    <span class="ico type-6">필라테스 주 2회 <span class="ic">OT</span></span>
                    -->
                                        <span class="ico type-2">
                                            필라테스 주 2회
                                            <span class="ic">그룹</span>
                                        </span>
                                        <div class="line">
                                            <span class="tit">이용기간</span>
                                            <span class="detail">2019-02-01 ~ 2019.09.01</span>
                                        </div>
                                        <div class="line">
                                            <span class="tit">남은횟수</span>
                                            <span class="detail">6/10 회</span>
                                        </div>
                                        <div class="line">
                                            <span class="tit">남은기간</span>
                                            <span class="detail"><span class="red">2일</span></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="com-tab">
                            <button :class="{ on: touchTab == 1 }" @click="touchTab = 1">출석체크</button>
                            <button :class="{ on: touchTab == 2 }" @click="touchTab = 2">사용중인 이용권</button>
                        </div>
                        <!-- 출석체크 목록 -->
                        <div v-show="touchTab == 1" class="attend-list">
                            <ul class="list">
                                <li>
                                    <span class="ico type-2">[그룹] 필라테스 주 2회</span>
                                    <div class="line">
                                        <span class="tit">유효기간</span>
                                        <span class="detail">
                                            2019.02.27 ~ 2020.02.27
                                            <br />
                                            11/20 회 (268 일 남음)
                                        </span>
                                    </div>
                                    <div class="line">
                                        <span class="tit">수업시간</span>
                                        <span class="detail">09:00 (담당 : 이지아)</span>
                                    </div>
                                    <div class="line">
                                        <span class="tit">장소</span>
                                        <span class="detail">GX 룸</span>
                                    </div>
                                    <div class="line">
                                        <span class="tit">프로그램</span>
                                        <span class="detail">매트 필라테스</span>
                                    </div>
                                    <div class="btn-line">
                                        <button class="attend-btn">출석하기</button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- //출석체크 목록 -->
                        <!-- 사용중인 이용권 목록 -->
                        <div v-show="touchTab == 2" class="attend-table">
                            <div class="com-table-top">
                                <table class="com-table">
                                    <colgroup>
                                        <col style="width: 380px" />
                                        <col style="width: 220px" />
                                        <col style="width: 180px" />
                                        <col style="width: 150px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>이용권명</th>
                                            <th>이용기간</th>
                                            <th>수업현황</th>
                                            <th>등록일자</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>[개인] 필라테스 10회</td>
                                            <td>2020.01.10 ~ 2020.01.30</td>
                                            <td>
                                                8/10 회
                                                <strong>
                                                    (출석
                                                    <span class="red">6</span>
                                                    / 결석
                                                    <span class="red">2</span>
                                                    )
                                                </strong>
                                            </td>
                                            <td>2020.01.10</td>
                                        </tr>
                                        <tr>
                                            <td colspan="100">등록된 내용이 없습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- //사용중인 이용권 목록 -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 터치출석 팝업 -->

        <!-- 직원 호출 알림 얼럿 -->
        <image-alert-2
            v-if="isCallEmployeeNoti"
            imgUrl="/img/icons/user.png"
            title="직원 호출 요청 알림"
            body="직원 호출이 요청되었습니다."
            :isTimeLimit="true"
            @close-popup="onClickCallEmployeeNotiAlert"
        />

        <payment-link-dlg
            :customerId="customerId"
            :show="payLinkPop"
            :close="() => togglePayLinkPop(false)"
            :searchCustomer="() => onClickSearchCustomer()"
        />

        <!-- 회원 검색 팝업 -->
        <portal to="modals">
            <div v-show="userPop" class="layer-pop square-type" style="z-index: 9999; isolation: isolate">
                <div class="modal-overlay"></div>
                <div class="view-content" style="width: 65%">
                    <div class="scroll-area com-scroll-y">
                        <span class="sub-title">회원 검색 결과</span>
                        <div class="top-search-area">
                            <div class="right">
                                <input
                                    ref="refCustomerName"
                                    v-model="searchCustomerStr"
                                    class="w220"
                                    placeholder="회원명"
                                    type="text"
                                    v-on:keyup.enter="onSearchCustomer"
                                />
                                <button class="com-btn" @click="onSearchCustomer">검색</button>
                            </div>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 90px" />
                                <col style="width: 60px" />
                                <col style="width: 90px" />
                                <col style="width: 90px" />
                                <col style="width: 90px" />
                                <col style="width: 120px" />
                                <col style="width: 120px" />
                                <col style="width: 50px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>회원명</th>
                                    <th>성별</th>
                                    <th>닉네임</th>
                                    <th>연락처</th>
                                    <th>생년월일</th>
                                    <th>이용권명</th>
                                    <th>유효기간</th>
                                    <th>상태</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, index) in searchCustomerList" :key="index">
                                    <td>
                                        <span
                                            v-if="payLinkPop"
                                            class="link pointer"
                                            @click="handlePickCustomer(c)"
                                            style="color: #4780fd"
                                        >
                                            {{ c.namee }}
                                        </span>
                                        <span
                                            v-else
                                            @click="handleUserPopup(c)"
                                            class="link pointer"
                                            style="color: #4780fd"
                                        >
                                            {{ c.namee }}
                                        </span>
                                    </td>
                                    <td>{{ c.sex === 'W' ? '여성' : '남성' }}</td>
                                    <td>{{ c.nick_name }}</td>
                                    <td>{{ c.phone | phoneNumberFilter }}</td>
                                    <td>{{ getDateFormatFilter(c.birthday) }}</td>
                                    <td>{{ convertTicketTypeFormat(c.cp_ticket_type_cd) }} {{ c.cp_prod_nm || '' }}</td>
                                    <td>{{ c.cp_prod_start_end || '' }}</td>
                                    <td>
                                        {{
                                            c.status_cd === 'V'
                                                ? '유효'
                                                : c.status_cd === 'E'
                                                ? '만료'
                                                : c.status_cd === 'H'
                                                ? '홀딩'
                                                : '잠재'
                                        }}
                                    </td>
                                </tr>
                                <tr v-if="searchCustomerList.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-pagination
                            v-model="pagingInfo.page"
                            :per-page="pagingInfo.limit"
                            :total-rows="pagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event)"
                        ></b-pagination>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCancleSearchPop">취소</button>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
        <!-- 회원 검색 팝업 -->
        <CardComponent
            v-if="isOpenCard"
            :customerName="cardCustomerName"
            :productCheckType="cardProductCheckType"
            :customerImageUrl="cardCustomerImageUrl"
            :productName="cardProductName"
            :productExpireDate="cardProductExpireDate"
            @close-popup="onClickNoCardComponent"
        />
        <!-- 직원 호출 알림 얼럿 -->
        <image-alert-2
            v-if="isCallEmployeeNoti"
            imgUrl="/img/icons/user.png"
            title="직원 호출 요청 알림"
            body="직원 호출이 요청되었습니다."
            @close-popup="onClickCallEmployeeNotiAlert"
        ></image-alert-2>

        <payment-link-dlg
            :customerId="customerId"
            :show="payLinkPop"
            :close="() => togglePayLinkPop(false)"
            :searchCustomer="() => onClickSearchCustomer()"
        ></payment-link-dlg>
    </div>
</template>

<script>
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';
import moment from 'moment';
import { pagingInfo } from '@/assets/js/common';
import ImageAlert2 from '@/components/ImageAlert2';
import PaymentLinkDlg from '@/components/PaymentLinkDlg';
import { mapState } from 'vuex';
import CardComponent from '@/components/CardComponent.vue';

// We store the reference to the SSE client out here
// so we can access it from other methods
let sseClient;

export default {
    name: 'TopSearch',
    components: {
        ImageAlert2,
        PaymentLinkDlg,
        CardComponent,
    },
    mixins: [MixinAllowedMenu],
    props: {
        location: Array,
    },
    data() {
        return {
            menuList: Array,
            touchPop: false, // 터치출석 팝업
            touchTab: 1, // 터치출석 탭 번째
            userPop: false, // 회원검색 팝업
            searchCustomerStr: '', // 회원검색 시 검색창의 내용
            searchCustomerList: [], // 검색 시 나오는 검색 결과
            pagingInfo: { ...pagingInfo },
            pickedCustomerId: '', // 선택한 회원의 customerId
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보
            // isUseSms: true,
            c: {},
            isCallEmployeeNoti: false,
            payLinkPop: false,
            isOpenCard: false,
            cardCustomerName: '',
            cardProductCheckType: '',
            cardCustomerImageUrl: '',
            cardProductName: '',
            cardProductExpireDate: '',
            remains: {
                point: 0,
            },
            audio: null,
            audioEnabled: false,
        };
    },
    mounted() {
        this.menuList = this.$route.meta.gnbMenu;
        this.fetchUseSms();
        this.fetchContract();
        this.fetchRemainInfo();

        console.log(process.env.VUE_APP_SSE_URL);
        // sse
        sseClient = this.$sse.create({
            // url: `${process.env.VUE_APP_API_URL}/admin/api/sse/center/${this.centerId}`,
            url: `${process.env.VUE_APP_SSE_URL}/sse/center/${this.centerId}`,
            format: 'json',
            withCredentials: false,
            polyfill: true,
        });

        // Catch any errors (ie. lost connections, etc.)
        sseClient.on('error', (e) => {
            console.error('lost connection or failed to parse!', e);

            // If this error is due to an unexpected disconnection, EventSource will
            // automatically attempt to reconnect indefinitely. You will _not_ need to
            // re-add your handlers.
        });

        // Handle messages without a specific event
        sseClient.on('message', this.handleMessage);

        sseClient
            .connect()
            .then((sse) => {
                console.log("We're connected!");
            })
            .catch((err) => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        // 오디오 상호작용 조건 우회
        this.audio = new Audio('/audio/1_second_silence.mp3');
        document.addEventListener('click', this.enableAudio);
        document.addEventListener('keydown', this.enableAudio);
        document.addEventListener('touchstart', this.enableAudio);
    },
    computed: {
        limitAlertDay: {
            // 만료일을 표시할 기준 날수 지정 : 7일로 지정
            get() {
                return 7;
            },
        },
        isShowCareMenu() {
            const { getters } = this.$store;
            return getters['auth/isCareAdmin'] || getters['auth/isSystemAdmin'];
        },
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),
    },
    methods: {
        async fetchRemainInfo() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}`);
                const { data: pointData } = await paymentApi.get(`/admin/api/payment/point/${this.centerId}`);
                this.centerInfo = data;
                this.centerNames = [this.centerInfo.centerName, '직접 입력'];
                this.selectedCenterName = this.centerInfo.centerName;

                const { remains } = this;
                const points = pointData.point || 0;
                this.remains.point = points;
                console.log(points);
            } catch (e) {}
        },
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchCustomer();
        },
        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '운동복';
            }
        },
        getPeriodString(period) {
            if (period === undefined) {
                return '';
            }

            if (period < 0) {
              return '사용종료';
            } else if (period == 0) {
              return '당일만료';
            } else if (period <= this.limitAlertDay) {
                return `만료 ${period}일 전`;
            }
            return `${period}일 남음`;
        },
        onClickBtnAddMember() {
            this.checkAllowedClick('MB', 1, () => {
                this.$router.push({ path: '/madmin/member/edit' });
            });
        },

        onClickSearchCustomer() {
            console.log(this.pagingInfo);
            this.onSearchCustomer();
            this.userPop = true;
            this.$nextTick(function () {
                this.$refs.refCustomerName.focus();
            });
        },

        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                const { data } = await this.sendGetCustomer();
                console.log(data.items);
                this.setPageParams(data);
                this.searchCustomerList = data.items;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },

        // 페이징 파라미터 저장
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                this.customerInfo = data; // 가져온 그대로 customerInfo에 넣기
                const { editField } = this;

                editField.name = this.customerInfo.name;
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        async fetchUseSms() {
            try {
                const { data } = await this.getUseSms();
                // this.isUseSms = data;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchContract() {
            try {
                const { data } = await this.getContract();
                if (data && data.length) {
                    this.c = data[0];
                }
            } catch (e) {
                console.error(e);
            }
        },

        // 터치 모니터 로그인 창을 띄우기
        goPage() {
            const ret = window.open('/touch/main', '_black', null, false);
        },
        getUseSms() {
            if (parseInt(this.centerId, 10) !== 0) {
                return api.get('/admin/api/center/ftcontract/sms');
            }
            return false;
        },
        getContract() {
            if (parseInt(this.centerId, 10) !== 0) {
                return api.get(`/admin/api/ft/contract/program/list/${this.centerId}`);
            }
            return false;
        },
        // 회원 이름 클릭 시에 회원 정보 페이지로 이동하는 기능
        moveMemberPage(customerId) {
            this.$router.push({ name: 'memberInfo', params: { id: this.centerId }, query: { customerId } });
        },
        getDateFormatFilter(date) {
            return date.trim() ? moment(date).format('YYYY-MM-DD') : '';
        },
        // sse 직원 호출
        handleMessage(data, lastEventId) {
            console.log(data);
            // console.log(lastEventId);
            const { centerId, type, message } = data;
            if (type == 'callEmployee' && this.audioEnabled) {
                this.isCallEmployeeNoti = true;
                this.playAudio('call_employee.mp3'); // 오디오 재생 함수 호출
            } else if (type == 'callCard') {
                this.cardCustomerName = message.cardCustomerName;
                this.cardProductCheckType = message.cardProductCheckType;
                this.cardCustomerImageUrl = message.cardCustomerImageUrl;
                this.cardProductName = message.cardProductName;
                this.cardProductExpireDate = message.cardProductExpireDate;
                this.isOpenCard = true;
            } else if (type == 'callSound') {
                if (message.soundOption == 'S') {
                    this.speak(message.speakMessage);
                } else if (message.soundOption == 'M') {
                    if (message.soundType == 'T') {
                        this.playAudio('attendance_entrance.mp3');
                    } else if (message.soundType == 'F') {
                        this.playAudio('invalid_attendance_entrance.mp3');
                    } else if (message.soundType == 'E') {
                        this.playAudio('expiring_attendance_entrance.mp3');
                    }
                }
            }
        },
        onClickCallEmployeeNotiAlert() {
            this.isCallEmployeeNoti = false;
        },
        togglePayLinkPop(open) {
            if (open) {
                if (!this.isAllowed('LE', 1)) {
                    alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                    return;
                }

                if (!this.isAllowed('SA', 'FITPAY')) {
                    if (confirm('핏페이 가입을 해야 이용할수 있는 기능입니다.\n 지금 신청하시겠습니까?.')) {
                        this.$router.push({ path: `/madmin/setting/center/${this.centerId}/fitpay` });
                    }
                    return;
                }
            }

            this.customerId = '';
            this.payLinkPop = open;
        },
        handlePickCustomer(customer) {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];

            this.customerId = String(customer.center_cust_id || '');
        },

        handleUserPopup(customer) {
            this.customerId = String(customer.center_cust_id || '');
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
            this.$router.push(`/madmin/member/payment/${this.centerId}?customerId=${this.customerId}`);
        },
        onClickNoCardComponent() {
            this.isOpenCard = false;
        },
        playAudio(filename) {
            const audio = new Audio(`/audio/${filename}`);
            audio.play().catch((error) => {
                console.error('Audio playback failed:', error);
            });
        },
        enableAudio() {
            if (!this.audioEnabled) {
                this.audio
                    .play()
                    .then(() => {
                        this.audio.pause();
                        this.audioEnabled = true;
                        document.removeEventListener('click', this.enableAudio);
                        document.removeEventListener('keydown', this.enableAudio);
                        document.removeEventListener('touchstart', this.enableAudio);
                    })
                    .catch((error) => {
                        console.error('Audio playback failed:', error);
                    });
            }
        },
        speak(text) {
            const utterance = new SpeechSynthesisUtterance(text);
            window.speechSynthesis.speak(utterance);
        },
    },
    watch: {
        centerId(val) {
            this.fetchUseSms();
            this.fetchContract();
        },
    },
    // sse closed
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        sseClient.disconnect();

        // Alternatively, we could have added the `sse: { cleanup: true }` option to our component,
        // and the SSEManager would have automatically disconnected during beforeDestroy.
    },
};
</script>
<style lang="scss" scoped></style>
